/**
 * @fileoverview Modal de confirmación para iniciar/finalizar tareas
 */

import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Alert } from 'reactstrap';

const ModalConfirmarTarea = ({ 
  isOpen, 
  toggle, 
  onConfirm, 
  onCancel,
  tipo, // 'iniciar' o 'finalizar'
  tarea,
  loading = false
}) => {
  const handleConfirm = () => {
    onConfirm();
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    } else {
      toggle();
    }
  };

  const getTitle = () => {
    return tipo === 'iniciar' ? 'Iniciar Tarea' : 'Finalizar Tarea';
  };

  const getMessage = () => {
    if (tipo === 'iniciar') {
      return `¿Está seguro que desea iniciar la tarea de prioridad ${tarea?.prioridad}?`;
    } else {
      return `¿Está seguro que desea finalizar la tarea de prioridad ${tarea?.prioridad}?`;
    }
  };

  const getConfirmButtonColor = () => {
    return tipo === 'iniciar' ? 'success' : 'warning';
  };

  const getConfirmButtonText = () => {
    return tipo === 'iniciar' ? 'Iniciar Tarea' : 'Finalizar Tarea';
  };

  return (
    <Modal isOpen={isOpen} toggle={handleCancel} centered>
      <ModalHeader toggle={toggle}>
        {getTitle()}
      </ModalHeader>
      <ModalBody>
        <div className="mb-3">
          <h6>Información de la Tarea:</h6>
          <div className="bg-light p-3 rounded">
            <p className="mb-1">
              <strong>Orden:</strong> {tarea?.expand?.orden?.numero || 'N/A'}
            </p>
            <p className="mb-1">
              <strong>Producto:</strong> {tarea?.expand?.orden?.nombre_producto || 'N/A'}
            </p>
            <p className="mb-1">
              <strong>Centro:</strong> {tarea?.expand?.centro_costo?.nombre || 'N/A'}
            </p>
            <p className="mb-0">
              <strong>Prioridad:</strong> {tarea?.prioridad || 'N/A'}
            </p>
          </div>
        </div>
        
        <Alert color="info" className="mb-0" timeout={0}>
          {getMessage()}
        </Alert>
      </ModalBody>
      <ModalFooter>
        <Button 
          color="secondary" 
          onClick={handleCancel}
          disabled={loading}
        >
          Cancelar
        </Button>
        <Button 
          color={getConfirmButtonColor()} 
          onClick={handleConfirm}
          disabled={loading}
        >
          {loading ? (
            <>
              <span data-testid="loading-spinner" className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
              Procesando...
            </>
          ) : getConfirmButtonText()}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ModalConfirmarTarea;
